<template>
  <div class="col-span-12 md:col-span-6 lg:col-span-3">
    <div
      class="bg-surface-0 dark:bg-surface-900 shadow-md p-4 rounded-md bg-white"
    >
      <div class="flex justify-between mb-3">
        <div>
          <span
            class="block text-surface-500 dark:text-surface-300 font-medium mb-3"
          >Monthly Income</span>
          <div
            class="text-surface-900 dark:text-surface-0 font-medium !text-xl"
          >
            <b>{{ income }}</b>
          </div>
        </div>
        <div
          class="flex items-center justify-center bg-yellow-100 dark:bg-yellow-400/30 rounded-md icon"
        >
          <i
            class="pi pi-dollar text-yellow-500 dark:text-yellow-200 !text-xl"
          />
        </div>
      </div>
      <span class="text-green-500 font-medium">%52+</span>
      <span class="text-surface-500 dark:text-surface-300" />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const income = ref("500,000");
</script>

<style scoped>
.icon {
    width: 40px;
    height: 40px;
}
</style>
